import { SchematicAPI } from '../actions/schematicAPI';
import { ServerActions } from '../actions/serverActions';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
const { ActionTypes } = Constants;

export const TerritoryActions = {
    territoryChanged: function (selectedTerritory, autoSelected = false) {
        dispatcher.dispatch({
            type: ActionTypes.TERRITORY_CHANGED,
            selectedTerritory: selectedTerritory,
            autoSelected: autoSelected
        });

        if (!autoSelected)
            SchematicAPI.clearSubdivision();

        if (selectedTerritory !== "0" && selectedTerritory !== "1") {
            ServerActions.getTerritoryDetail(selectedTerritory);
        }
    },

};
